<template>
  <div>
    <v-navigation-drawer disable-resize-watcher v-model="sidebar" app>
      <v-list>
        <v-list-item v-for="item in menuItems" :key="item.title" :to="item.link">
          <v-list-item-content>{{ item.title }}</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="#0b7078" dark>
      <v-icon class="hidden-md-and-up mr-3" v-on:click="sidebar = !sidebar">fas fa-bars</v-icon>
      <div class="d-flex align-center">
        <v-img alt="SSC Logo" :src="require('../assets/Logo_Horizontal_Light.svg')" width="220" />
        <span class="ml-3 logo-text text-lowercase"></span>
        <span class="text-small mt-2">

        </span>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        v-for="item in menuItems"
        :key="item.title"
        :to="item.link"
        :ripple="false"
        class="barUnder hidden-sm-and-down"
        text
      >
        <span class>{{item.title}}</span>
      </v-btn>
    </v-app-bar>
  </div>
</template>
<script>
export default {
  name: "NavigationBar",
  data: () => ({
    menuItems: [
      { title: "BLOCKS", link: "/" },
      { title: "LOCATE", link: "/locate" },
      { title: "ABOUT", link: "/about" },
    ],
    sidebar: false
  })
}
</script>

<style scoped>
.v-btn {
  text-transform: none !important;
  height: 100% !important;
  border-radius: 0 !important;
}
.v-btn::before {
  background-color: transparent;
}
.barUnder {
  border-bottom: 4px solid transparent;
}
.blankBarUnder {
  border-bottom: 4px solid transparent;
}
.barUnder:hover,
.barUnder:focus,
.barUnder:active {
  border-bottom: 4px solid #00454c;
  /*background-color: #3d2645;*/
}

.logo-text {
  font-weight: 500;
  font-size: 18pt;
  margin-top: -10px;
}
.text-small {
  font-size: 14px;
  position: absolute;
  margin-left: 90px;
  color: #fff;
  font-weight: 100;
}
</style>